import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getPathApp } from '../utils/util';

const pathurl = getPathApp(window);
const LogoutRoute = ({ component: Component, ...rest }) => {
    localStorage.removeItem('auth-token');
    localStorage.removeItem('user');
    localStorage.removeItem('ship-security');
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify({ messageType: 'logoutClearCookieManager', value: true }));
        }
    }
    return (
        <Route
            {...rest}
            render={(props) => (
                <Redirect
                    to={{
                        pathname: `${pathurl}/login`,
                        state: { from: props.location }
                    }}
                />
            )}
        />
    );
};

export default LogoutRoute;
